var _this = this;

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";

function _newArrowCheck(innerThis, boundThis) { if (innerThis !== boundThis) { throw new TypeError("Cannot instantiate an arrow function"); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'yx-pagination',
  props: {
    layout: {
      type: String,
      "default": 'prev, pager, next'
    },
    el: {
      // 接收 HTMLElement、VueComponent两种类型
      // 如果el = 带有y轴滚动条el-table Vue实列，则滚动el-table的内部滚动条到顶 部
      // 其他情况则滚动该el元素的所在位置
      "default": null
    },
    pageOption: {
      type: Object,
      required: true,
      "default": function _default() {
        _newArrowCheck(this, _this);

        return {
          total: 0,
          prevText: '上一页',
          nextText: '下一页',
          query: {
            pageSize: 20,
            pageNum: 1
          }
        };
      }.bind(this)
    }
  },
  data: function data() {
    return {
      option: {
        pageSize: this.pageOption.query.pageSize,
        currentPage: this.pageOption.query.pageNum,
        total: this.pageOption.total,
        prevText: this.pageOption.prevText || '上一页',
        nextText: this.pageOption.nextText || '下一页'
      }
    };
  },
  mounted: function mounted() {// 这里获取不到el 第一时间el为null
  },
  methods: {
    currentChange: function currentChange(current) {
      this.$emit('current', current);

      if (this.el) {
        this.scrollTo();
      } else {
        window.scrollTo(0, 0);
      }
    },
    prevClick: function prevClick(current) {
      this.currentChange(current); // this.$emit('prev', current)
    },
    nextClick: function nextClick(current) {
      this.currentChange(current); // this.$emit('next', current)
    },
    scrollTo: function scrollTo() {
      var el = this.el.$el ? this.el.$el : this.el;

      if (el.style.height || el.style.maxHeight) {
        this.el.bodyWrapper.scrollTo(0, 0);
      } else {
        window.scrollTo(0, this.getOffsetTop(el));
      }
    },
    // 获取元素到顶部的距离
    getOffsetTop: function getOffsetTop(el) {
      var offsetTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (el.nodeName === 'BODY') {
        return offsetTop;
      }

      offsetTop += el.offsetTop;
      return this.getOffsetTop(el.offsetParent, offsetTop);
    }
  },
  watch: {
    pageOption: {
      handler: function handler(val, oldVal) {
        this.option.pageSize = this.pageOption.query.pageSize;
        this.option.total = this.pageOption.total;
        this.option.currentPage = this.pageOption.query.pageNum;
        this.option.prevText = this.pageOption.prevText || '上一页';
        this.option.nextText = this.pageOption.nextText || '下一页';
      },
      deep: true
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}
/* script */


var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.option.total ? _c("div", {
    staticClass: "yx-pagination"
  }, [_c("el-pagination", _vm._b({
    attrs: {
      background: "",
      "page-size": _vm.option.pageSize,
      "prev-text": _vm.option.prevText,
      "next-text": _vm.option.nextText,
      "current-page": _vm.option.currentPage,
      layout: _vm.layout,
      total: _vm.option.total
    },
    on: {
      "current-change": _vm.currentChange,
      "prev-click": _vm.prevClick,
      "next-click": _vm.nextClick
    }
  }, "el-pagination", _vm.$attrs, false))], 1) : _vm._e();
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

__vue_component__.install = function (Vue) {
  _newArrowCheck(this, _this);

  Vue.component(__vue_component__.name, __vue_component__);
}.bind(this);

export default __vue_component__;
